export default __webpack_public_path__ + "static/facts-age-d8b0f68c65a23367ff8ea54551b63d76.webp";